// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__D74z-","root_fullWidth":"Textarea_root_fullWidth__1J-FK","root_error":"Textarea_root_error__1oJaM"};